import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "../styles/tournamentDetails.css";
import { useEffect, useState, useCallback } from "react";
import banner from "../assets/images/tournament-banner.png";
import { API_CONFIG } from "../config/api";
import { generateAuthToken, generateURN } from "../components/hmac";

function formatTournamentDate(startDateStr, durationDays = 3) {
  const start = new Date(startDateStr);
  const end = new Date(start);
  end.setDate(start.getDate() + durationDays - 1);

  const month = start.toLocaleString("en-US", { month: "long" });
  const startDay = start.getDate();
  const endDay = end.getDate();
  const year = start.getFullYear();

  return `${month} ${startDay}-${endDay}, ${year}`;
}

const TournamentDetails = () => {
  const { tournamentID } = useParams();
  const [tournament, setTournament] = useState({});
  const navigate = useNavigate();

  const fetchTournament = useCallback(async () => {
    try {
      const { host, fetchTournamentById, basic } = API_CONFIG;
      const urn = generateURN();
      const authToken = generateAuthToken(urn);

      const res = await fetch(
        `https://${host}${fetchTournamentById.path(tournamentID)}`,
        {
          method: fetchTournamentById.method,
          credentials: "include",
          headers: {
            Authorization: `Basic ${basic.BASIC_AUTH_CWUSER}`,
            urn,
            authToken,
          },
        }
      );

      const json = await res.json();
      const data = json.apiResponseData.responseData;
      setTournament(data);
    } catch (error) {
      console.error("API ERROR", error);
    }
  }, [tournamentID]);

  useEffect(() => {
      fetchTournament();
  }, [fetchTournament, tournamentID]);

  return (
  <section className="tournament-page">
    <div className="card">
      {/* ✅ BACK BUTTON */}
      <button className="back-btn" onClick={() => navigate(-1)}>
        ← Back
      </button>
      <h1 id="top">{tournament.tournamentName}</h1>

      <div className="part-1">
        <div className="text">
          <h3>{tournament.info}</h3>
          <h3>{formatTournamentDate(tournament.date, 2)}</h3>
          <h3>{`Format: ${tournament.format}`}</h3>
          <h3>
            {tournament.tournamentStatus === 0
              ? "Status: Completed"
              : "Status: Ongoing"}
          </h3>
          <p>{tournament.description}</p>
          <a
            href={tournament.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            Register
          </a>
        </div>
        <img className="tour-banner" src={banner} alt="banner" />
      </div>

      <div className="part-2">
        <h2>Players</h2>
        {tournament?.playerList?.length > 0 && (
          <ol className="list">
            {tournament.playerList.map((player, index) => (
              <li key={index}>{player}</li>
            ))}
          </ol>
        )}
      </div>
    </div>
  </section>
);
};

export default TournamentDetails;
